import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, "");
const API = `${BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const authAPI = {
  sendOTP: (phone) => axios.post(`${API}/auth/send-otp`, { phone }),
  signup: (data) => axios.post(`${API}/auth/signup`, data),
  login: (data) => axios.post(`${API}/auth/login`, data),
  googleLogin: (data) => axios.post(`${API}/auth/google`, data),
  adminLogin: (username, password) => axios.post(`${API}/auth/admin-login?username=${username}&password=${password}`),
  getMe: () => axios.get(`${API}/auth/me`, { headers: getAuthHeader() }),
};

export const providerAPI = {
  createProfile: (data) => axios.post(`${API}/provider/profile`, data, { headers: getAuthHeader() }),
  getProfile: (userId) => axios.get(`${API}/provider/profile/${userId}`),
  updateProfile: (userId, data) => axios.put(`${API}/provider/profile/${userId}`, data, { headers: getAuthHeader() }),
  getProviders: (params) => axios.get(`${API}/providers`, { params }),
  getProvider: (userId) => axios.get(`${API}/providers/${userId}`),
};

export const pingAPI = {
  createPing: (providerId) => axios.post(`${API}/pings`, { provider_id: providerId }, { headers: getAuthHeader() }),
  getProviderPings: (providerId) => axios.get(`${API}/pings/provider/${providerId}`, { headers: getAuthHeader() }),
  markViewed: (pingId) => axios.put(`${API}/pings/${pingId}/mark-viewed`, {}, { headers: getAuthHeader() }),
};

export const adminAPI = {
  getUsers: () => axios.get(`${API}/admin/users`, { headers: getAuthHeader() }),
  deleteUser: (userId) => axios.delete(`${API}/admin/users/${userId}`, { headers: getAuthHeader() }),
  getProviders: () => axios.get(`${API}/admin/providers`, { headers: getAuthHeader() }),
  exportData: () => axios.get(`${API}/admin/export`, { headers: getAuthHeader(), responseType: 'blob' }),
};